export default {
    inquiry: 'Inquiry',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    name: 'Name',
    status: 'Status',
    department: 'Department',
    statusStart: 'Status Start',
    group: 'Group',
    personalLeave: 'Personal Leave',
    quota: 'Quota',
    used: 'Used',
    sickLeave: 'Sick Leave',
    onSite: 'Onsite',
    count: 'Count',
    startStatus: 'Status Start',
    endStatus: 'Status End',
    inquiryStatus: 'Inquiry Status',
    description: 'Description',
    approve: 'Approve',
    reject: 'Reject',
    contact: 'Contact',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    congratulation: 'Congratulation',
    redirecting: 'Redirecting',
    returnToInuiry: 'This page will automaically return to inquiry page in 3 seconds',
    applicationStatus: 'application status of',
    isUpdated: 'is updated, This page will automaically return to inquiry page in 3 seconds',
    attachment: 'Attachment',
    downloadFile: 'Download File',
    checkInLocation: 'Check - In location',
    amTime: 'AM',
    pmTime: 'PM'
}
